import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, debounceTime, fromEvent, takeUntil } from 'rxjs';

export interface Menu {
  headTitle1?: string;
  level?: number;
  headTitle2?: string;
  path?: string;
  title?: string;
  type?: string;
  icon?: string;
  active?: boolean;
  bookmark?: boolean;
  pinnedData?: boolean;
  items?: Menu[];
  children?: Menu[];
}

@Injectable({
  providedIn: 'root'
})
export class NavService {
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  private unsubscriber: Subject<any> = new Subject();

  public language: boolean = false;

  public collapseSidebar: boolean = window.innerWidth < 1200 ? true : false;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, 'resize')
      .pipe(debounceTime(0), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 1200) {
          this.collapseSidebar = true;
        } else {
          this.collapseSidebar = false;
        }
      });
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  MENUITEMS: Menu[] = [
    {
      headTitle1: 'General'
    },
    {
      level: 1,
      title: 'role.roles',
      icon: 'others',
      type: 'sub',
      active: false,
      children: [
        { path: '/role/role-list', title: 'role.role_list', type: 'link' },
        { path: '/role/role-new', title: 'role.add_role', type: 'link' }
      ]
    },
    {
      level: 1,
      title: 'user.users',
      icon: 'user',
      type: 'sub',
      active: false,
      children: [
        { path: '/user/users-profile', title: 'user.user_profile', type: 'link' },
        { path: '/user/edit-profile', title: 'user.edit_profile', type: 'link' },
        { path: '/user/users-cards', title: 'user.users-cards', type: 'link' },
        { path: '/user/create-new', title: 'user.add_user', type: 'link' }
      ]
    },
    {
      level: 1,
      title: 'Test Form',
      icon: 'file-text',
      type: 'link',
      active: false,
      path: '/test-form'
    },
    {
      level: 1,
      title: 'Test Table',
      icon: 'file-text',
      type: 'link',
      active: false,
      path: '/test-table'
    },
    {
      level: 1,
      title: 'Impostazioni',
      icon: 'settings',
      type: 'link',
      active: false,
      path: '/impostazioni'
    }
  ];
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

  ngOnDestroy() {
    this.unsubscriber.complete();
  }
}
